//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        props:{
            visibility: {
                type: Boolean,
                default: false,
            },
            startDate:{
                type: Object,
                default: {
                    year: '',
                    month: '',
                    day: ''
                }
            }
        },
        data() {
            return {
                arrDays: [],
                newarrDays: [],
                chooseDate:this.startDate
            }
        },
        watch: {
            chooseDate(newValue, oldValue) {
                var _this = this;
                _this.chooseDate = newValue;
                _this.processData(_this.chooseDate,_this.arrDays);
            }
        },
        mounted() {
            const date = new Date()
            this.days = []
            let month = date.getMonth() + 1;
            const year = date.getFullYear();
            for (let i = 0; i < 12; i++) {
                if (month > 12) {
                    this.initData(this.formatDate(year + 1, month - 12, 1));
                } else {
                    this.initData(this.formatDate(year, month, 1));
                }
                month += 1
            }
            this.processData(this.chooseDate,this.arrDays);
        },
        methods: {
            processData(curData,totalData){
                const date = new Date()
                const currentYear = date.getFullYear()
                const currentMonth = date.getMonth()+1
                const currentDay = date.getDate()

                totalData.map((item)=>{ // 整个日历数据
                    if(item.year == curData.year && item.moth == curData.month){
                        item.newdays.map((pice,index) => {
                            if(pice.name == curData.day){
                                pice.showActive = true
                            }else{
                                pice.showActive = false
                            }
                        })
                    }
                    item.newdays.map((one,index) => {
                        if(one.name == 1){
                            item.hid = index-1
                        } 
                    })
                    if(item.year == currentYear && item.moth == currentMonth){
                        item.newdays.map((pice,index) => {
                            if(pice.name < currentDay){
                                pice.show = false
                            }else{
                                pice.show = true

                            }
                        })
                    }else{
                        item.newdays.map((pice,index) => {
                            pice.show = true
                        })
                    }
                })
                this.newarrDays = totalData
            },
            initData(cur) {
                let self = this
                let date = new Date(cur);
                let currentDay = date.getDate();
                let currentYear = date.getFullYear();
                let currentMonth = date.getMonth() + 1;
                let currentWeek = date.getDay(); // 1...6,0

                let arr = []
                let newArray = []
                let str = this.formatDate(currentYear, currentMonth, currentDay);
                
                this.days.length = 0;

                for (let i = currentWeek; i >= 0; i--) {
                    let d = new Date(str);
                    d.setDate(d.getDate() - i);

                    arr.push(d);
                    newArray.push({'name':d.getDate()});
                }
                for (let i = 1; i <= 42 - currentWeek; i++) {

                    let d = new Date(str);
                    
                    d.setDate(d.getDate() + i);

                    if (currentMonth == (d.getMonth() + 1)) {
                        arr.push(d);
                        newArray.push({'name':d.getDate()});
                    }

                }
                let obj = {}
                obj.moth = currentMonth
                obj.days = arr
                obj.newdays = newArray
                obj.year = currentYear
                self.arrDays.push(obj)
            },
            formatDate(year, month, day) {
                let y = year;
                let m = month;
                if (m < 10) m = "0" + m;
                let d = day;
                if (d < 10) d = "0" + d;
                return y + "-" + m + "-" + d
            },
            selectDayClick(data, day) {
                let time = {
                    year: data.year,
                    month: data.moth < 10 ? '0' + data.moth : data.moth,
                    day: day <10 ? '0'+ day : day,
                    allTime: data.year + '-' + (data.moth < 10 ? '0' + data.moth : data.moth) + '-' + (day <10 ? '0'+ day : day)
                }
                this.$emit('clickDay', time);
            }
        }
    }
